import { EntityLevel } from '@suntex.fim/enums'

/**
 * Resolves which entity the Fluency Games report fetches.
 *
 * A player viewing their own progress is fetched at Player level; the team-level
 * report omits family/teacher accounts, so those players would otherwise be
 * missing and the report would never load. The team/admin report uses Team
 * level to get the full roster.
 */
export function resolveFluencyGamesEntity(
  isPlayerReport: boolean,
  playerId: number | undefined,
  teamId: number | undefined
): { id: number; level: EntityLevel; enabled: boolean } {
  if (isPlayerReport) {
    return {
      id: playerId ?? 0,
      level: EntityLevel.Player,
      enabled: playerId != null && playerId > 0
    }
  }

  return {
    id: teamId ?? 0,
    level: EntityLevel.Team,
    enabled: teamId != null
  }
}
